import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { footerColumns, legalLinks } from '../../data/footerLinks';
import { Brand } from './Brand';
const badges = ['Since 2002', '1000+ websites', '100+ integrations', '0% transaction fees from us'];
export function Footer() {
  return <footer className="relative overflow-hidden border-t border-white/10 bg-ink" data-id="element-407" data-mp="5msvjqzfs0z7">
      <div className="absolute inset-0 bp opacity-50" aria-hidden="true" data-id="element-408" data-mp="pkfbvxum70l" />

      <div className="relative mx-auto max-w-8xl px-5 py-14 sm:px-8 lg:px-10 lg:py-16" data-id="element-409" data-mp="3s2f547sro4re">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-410" data-mp="3n32d78n1g7hy">
          <div className="lg:col-span-4" data-id="element-411" data-mp="3n1hmxv7rbapw">
            <Brand data-id="element-412" data-mp="3j2ihm9i45bxx" />
            <p className="mt-5 max-w-sm text-[13.5px] leading-relaxed text-mist-300" data-id="element-413" data-mp="3j3a48utqfzc2">
              We build custom websites, ecommerce, and connected web systems for business owners — and we have been doing it
              since 2002. Human-led strategy, AI-accelerated production, and support that does not end at launch.
            </p>
            <div className="mt-6 flex flex-wrap gap-2" data-id="element-414" data-mp="2kba19dmwtm76">
              {badges.map(b => <span key={b} className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 font-mono text-[9.5px] uppercase tracking-[0.16em] text-mist-300" data-id="element-415" data-mp="2p5xozaa3ackp">
                  {b}
                </span>)}
            </div>
            <div className="mt-7 flex flex-wrap gap-3" data-id="element-416" data-mp="33z9dksx4h1ep">
              <Link to="/#get-started" className="group inline-flex items-center gap-2 rounded-[10px] bg-forge-orange px-5 py-3 text-[14px] font-bold text-ink transition-transform hover:-translate-y-0.5" data-id="element-417" data-mp="381e43is9xhx4">
                Get Started
                <ArrowUpRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-418" data-mp="1inho2ul3u1qf" />
              </Link>
              <Link to="/portfolio" className="inline-flex items-center gap-2 rounded-[10px] border border-white/15 px-5 py-3 text-[14px] font-semibold text-white transition-colors hover:border-forge-cyan/60 hover:bg-white/5" data-id="element-419" data-mp="1no5f3g9c2ikn">
                See the portfolio
              </Link>
            </div>
          </div>

          <nav aria-label="Footer" className="grid gap-8 sm:grid-cols-3 lg:col-span-6 lg:col-start-6" data-id="element-420" data-mp="ps9smhx1nxzs">
            {footerColumns.map(col => <div key={col.heading} data-id="element-421" data-mp="ks5cwu3yn7am">
                <h2 className="font-mono text-[10px] uppercase tracking-[0.2em] text-forge-cyan" data-id="element-422" data-mp="fun89fwz7e8f">{col.heading}</h2>
                <ul className="mt-4 space-y-2.5" data-id="element-423" data-mp="bul5f3fi8erk">
                  {col.links.map(link => <li key={link.label} data-id="element-424" data-mp="6vibof4z5uyw">
                      <Link to={link.to} className="text-[13.5px] text-mist-200 transition-colors hover:text-white" data-id="element-425" data-mp="6wjlyhe62dfk">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </nav>

          <div className="lg:col-span-2" data-id="element-426" data-mp="28pwl72pcznyj">
            <h2 className="font-mono text-[10px] uppercase tracking-[0.2em] text-forge-cyan" data-id="element-427" data-mp="2dqke5tx5eeve">Talk to us</h2>
            <ul className="mt-4 space-y-3" data-id="element-428" data-mp="2ihkaoy2cuuxd">
              <li className="flex items-start gap-2.5 text-[13.5px] text-mist-200" data-id="element-429" data-mp="2ijwxppmyzvha">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-forge-orange" aria-hidden="true" data-id="element-430" data-mp="2ng3v2u1avynm" />
                Phone support, Mon–Fri
              </li>
              <li className="flex items-start gap-2.5 text-[13.5px] text-mist-200" data-id="element-431" data-mp="1urg4cixs8h2o">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-forge-orange" aria-hidden="true" data-id="element-432" data-mp="1zrkm0caffhuh" />
                Email and ticket support
              </li>
            </ul>
            <p className="mt-5 text-[12.5px] leading-relaxed text-mist-400" data-id="element-433" data-mp="23ql39qd9acfd">
              Love your site or get your money back — 30-day money-back option.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center sm:justify-between" data-id="element-434" data-mp="3f9xlblbls5x0">
          <p className="text-[12.5px] text-mist-400" data-id="element-435" data-mp="38sch8hi7fdgj">© {new Date().getFullYear()} WebsiteForge. All rights reserved.</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2 text-[12.5px] text-mist-400" data-id="element-436" data-mp="3nq509jmymjzh">
            {legalLinks.map(l => <li key={l.label} data-id="element-437" data-mp="3iopchjtedzde">
                <Link to={l.to} className="transition-colors hover:text-white" data-id="element-438" data-mp="k47j6t7slq6">
                  {l.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}